import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/welcome")({
  head: () => pageHead("page.welcome"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    if (!context.auth?.user) {
      throw redirect({ to: "/sign-in" });
    }
    if (context.auth.orgId == null) {
      throw redirect({ to: "/activate" });
    }
    // Already onboarded — skip welcome
    if (context.auth.onboarded) {
      throw redirect({ to: "/" });
    }
  },
});
